<script>
import DarkTheme from './dark'
import DarkFooter from '../../components/shared/dark-footer'

export default {
  components: { DarkFooter, DarkTheme },
  data () {
    return {}
  },
  methods: {}
}
</script>

<template>
  <div>
    <dark-theme >
      <slot />
      <dark-footer></dark-footer>
    </dark-theme>
  </div>
</template>
